export default __webpack_public_path__ + "static/media/47.274b0a69.png";